module.exports = __webpack_public_path__ + "static/fonts/iconfont.27776ba5.woff";